import {
  IPersonalityType,
  IUserData,
} from '../../../../../../services/hookService/getUserCooperationAgreementData/types';
import {format98To0} from '../../../../../../utilities/helper/formatPhoneNumber';
import {getPersianDateTime} from '../../../../../../utilities/helper/GetPersianDateTime';

const getAgreementFormInitialValues = (
  formData?: IUserData,
  userType?: IPersonalityType,
) => {
  // Base license fields for all users
  const baseLicenseFields = {
    personality_type: userType ?? '',
    license_number: formData?.store?.license_info?.license_number ?? '',
    // license_expiration_date:
    //   getPersianDateTimeV2(
    //     formData?.store?.license_info?.license_expiration_date,
    //   ) ?? '',
    license_issuance_date:
      getPersianDateTime(
        formData?.store?.license_info?.license_issuance_date,
      ) ?? '',
  };

  // For Individual users - only base fields
  if (userType === IPersonalityType.Individual) {
    return {
      name: formData?.name ?? '',
      national_code: formData?.national_code ?? '',
      store: {
        phone_number: format98To0(formData?.store?.phone_number) ?? '',
        address: formData?.store?.address ?? '',
        postal_code: formData?.store?.postal_code ?? '',
        license_info: baseLicenseFields,
        title: formData?.store?.title,
      },
    };
  }

  // For Corporate users - include corporate fields
  return {
    name: formData?.name ?? '',
    national_code: formData?.national_code ?? '',
    store: {
      phone_number: format98To0(formData?.store?.phone_number) ?? '',
      address: formData?.store?.address ?? '',
      postal_code: formData?.store?.postal_code ?? '',
      title: formData?.store?.title,
      license_info: {
        ...baseLicenseFields,
        company_name: formData?.store?.license_info?.company_name ?? '',
        national_company_code:
          formData?.store?.license_info?.national_company_code ?? '',
        registration_number:
          formData?.store?.license_info?.registration_number ?? '',
        first_legal_representative_name:
          formData?.store?.license_info?.first_legal_representative_name ?? '',
        first_legal_representative_code:
          formData?.store?.license_info?.first_legal_representative_code ?? '',
        first_legal_representative_phone_number:
          format98To0(
            formData?.store?.license_info
              ?.first_legal_representative_phone_number,
          ) ?? '',
        second_legal_representative_name:
          formData?.store?.license_info?.second_legal_representative_name ?? '',
        second_legal_representative_code:
          formData?.store?.license_info?.second_legal_representative_code ?? '',
        second_legal_representative_phone_number:
          format98To0(
            formData?.store?.license_info
              ?.second_legal_representative_phone_number,
          ) ?? '',
      },
    },
  };
};

export default getAgreementFormInitialValues;
